import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Badge } from 'react-bootstrap';
import { Card, Row, Col, Accordion, ProgressBar, Table } from 'react-bootstrap';
import HeaderQuoteAiView from './headerquoteAiView';
import SidebarQuoteAiViewPage from './sidebarquoteAiView';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import ContactInformationViewPage from './contactInformationViewPage';

const InsuredInformationViewPage = () => {
  const [activeKey, setActiveKey] = useState('0');
  const [insuredActiveKey, setInsuredActiveKey] = useState('0');
  const [contactActiveKey, setContactActiveKey] = useState('0');
  const [businessActiveKey, setBusinessActiveKey] = useState('0');
  const [addressActiveKey, setaddressActiveKey] = useState('0');
  const [employmentActiveKey, setemploymentActiveKey] = useState('0');
  const [ratingActiveKey, setratingActiveKey] = useState('0');
  const [deductibleActiveKey, setdeductibleActiveKey] = useState('0');
  const [includeActiveKey, setincludeActiveKey] = useState('0');
  const [questionActiveKey, setquestionActiveKey] = useState('0');
  const [lossdetailActiveKey, setlossdetailActiveKey] = useState('0');
  const [additionformActiveKey, setadditionformActiveKey] = useState('0');
  const [quotedpremiumActiveKey, setquotedpremiumActiveKey] = useState('0');

  const refs = {
    InsuredInformation: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-file-text h-3.5 w-3.5 mr-1.5"
        >
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M10 9H8"></path>
          <path d="M16 13H8"></path>
          <path d="M16 17H8"></path>
        </svg>
      ),
    },
    ContactInformation: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-users h-3.5 w-3.5 mr-1.5"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
    },
    PolicyTerm: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-building h-3.5 w-3.5 mr-1.5"
        >
          <rect width="16" height="20" x="4" y="2" rx="2" ry="2"></rect>
          <path d="M9 22v-4h6v4"></path>
          <path d="M8 6h.01"></path>
          <path d="M16 6h.01"></path>
          <path d="M12 6h.01"></path>
          <path d="M12 10h.01"></path>
          <path d="M12 14h.01"></path>
          <path d="M16 10h.01"></path>
          <path d="M16 14h.01"></path>
          <path d="M8 10h.01"></path>
          <path d="M8 14h.01"></path>
        </svg>
      ),
    },
    Locations: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-map-pin h-3.5 w-3.5 mr-1.5"
        >
          <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
      ),
    },
    LocationClassCodes: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-dollar-sign h-3.5 w-3.5 mr-1.5"
        >
          <line x1="12" x2="12" y1="2" y2="22"></line>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
        </svg>
      ),
    },
    PreQualifierQuestions: {
      ref: useRef(null),
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm1 15h-2v-2h2zm0-4h-2V7h2z" />
        </svg>
      ),
    },
    RatingInformation: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-shield h-3.5 w-3.5 mr-1.5"
        >
          <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
        </svg>
      ),
    },
    Deductibles: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-wallet h-3.5 w-3.5 mr-1.5"
        >
          <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
          <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
        </svg>
      ),
    },
    LossDetails: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-file-chart-column-increasing h-3.5 w-3.5 mr-1.5"
        >
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M8 18v-2"></path>
          <path d="M12 18v-4"></path>
          <path d="M16 18v-6"></path>
        </svg>
      ),
    },
    IncludedExcludedOfficers: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-user-cog h-3.5 w-3.5 mr-1.5"
        >
          <circle cx="18" cy="15" r="3"></circle>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M10 15H6a4 4 0 0 0-4 4v2"></path>
          <path d="m21.7 16.4-.9-.3"></path>
          <path d="m15.2 13.9-.9-.3"></path>
          <path d="m16.6 18.7.3-.9"></path>
          <path d="m19.1 12.2.3-.9"></path>
          <path d="m19.6 18.7-.4-1"></path>
          <path d="m16.8 12.3-.4-1"></path>
          <path d="m14.3 16.6 1-.4"></path>
          <path d="m20.7 13.8 1-.4"></path>
        </svg>
      ),
    },
    UnderwritingInformation: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-triangle-alert h-3.5 w-3.5 mr-1.5"
        >
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
          <path d="M12 9v4"></path>
          <path d="M12 17h.01"></path>
        </svg>
      ),
    },
    AdditionalInformationForms: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-file-spreadsheet h-3.5 w-3.5 mr-1.5"
        >
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M8 13h2"></path>
          <path d="M14 13h2"></path>
          <path d="M8 17h2"></path>
          <path d="M14 17h2"></path>
        </svg>
      ),
    },
    QuotedPremium: {
      ref: useRef(null),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-receipt h-3.5 w-3.5 mr-1.5"
        >
          <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"></path>
          <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path>
          <path d="M12 17.5v-11"></path>
        </svg>
      ),
    },
  };

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAiView />
        <div className="QuotesSummaryView">
          <div className=" container-fluid ">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-2">
                <div className="sticky-top">
                  <SidebarQuoteAiViewPage refs={refs} />
                </div>
              </div>

              <div className="col-12 col-md-12 col-lg-7 gx-2 scrollquote_content">
                <div
                  id="InsuredInformation"
                  className="scrollTo"
                  ref={refs.InsuredInformation}
                ></div>
                <div className="col-12 mb-3">
                  <Accordion activeKey={insuredActiveKey} onSelect={(k) => setInsuredActiveKey(k)}>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-file-text h-3.5 w-3.5 mr-1.5"
                          >
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                            <path d="M10 9H8"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                          </svg>
                          <span> Insured & Policy Summary</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <Row>
                            {/* Left Column */}
                            <Col md={6}>
                              <div className="detail-item">
                                <small className="text-subtle">Insured Name</small>
                                <p className="digit_txt fw-medium">Acme Corporation</p>
                              </div>
                              <div className="detail-item">
                                <small className="text-subtle">FEIN/Tax ID</small>
                                <p className="digit_txt">12-3456789</p>
                              </div>
                              <div className="detail-item">
                                <small className="text-subtle">Primary Business State</small>
                                <p className="digit_txt">California</p>
                              </div>
                              <div className="detail-item">
                                <small className="text-subtle">Website</small>
                                <p className="digit_txt">
                                  <a
                                    href="https://acmecorp.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    https://acmecorp.com
                                  </a>
                                </p>
                              </div>
                            </Col>

                            {/* Right Column */}
                            <Col md={6}>
                              <div className="detail-item">
                                <small className="text-subtle">Policy Term</small>
                                <p className="digit_txt">12 Months</p>
                              </div>
                              <div className="detail-item">
                                <small className="text-subtle">Effective Date</small>
                                <p className="digit_txt">January 1, 2023</p>
                              </div>
                              <div className="detail-item">
                                <small className="text-subtle">IMS Control Number</small>
                                <p className="digit_txt">WC-2023-0042</p>
                              </div>
                              <div className="detail-item">
                                <small className="text-subtle">Total Premium Amount</small>
                                <p className="digit_txt fw-medium">$12,450.00</p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div
                  id="ContactInformation"
                  className="scrollTo"
                  ref={refs.ContactInformation}
                ></div>
                <div className="col-12 mb-3">
                  <Accordion activeKey={contactActiveKey} onSelect={(k) => setContactActiveKey(k)}>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-users h-3.5 w-3.5 mr-1.5"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                          </svg>

                          <span>Contact Information</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <Row className="mb-3">
                            <Col md={3}>
                              <small className="text-subtle">First Name</small>
                              <p className="digit_txt">John</p>
                            </Col>
                            <Col md={3}>
                              <small className="text-subtle">Middle Name</small>
                              <p className="digit_txt">A</p>
                            </Col>
                            <Col md={3}>
                              <small className="text-subtle">Last Name</small>
                              <p className="digit_txt">Smith</p>
                            </Col>
                            <Col md={3}>
                              <small className="text-subtle">Office Number</small>
                              <p className="digit_txt">(555) 123-4567</p>
                            </Col>
                          </Row>

                          <Row>
                            <Col md={6}>
                              <small className="text-subtle">Email Address</small>
                              <p className="digit_txt">
                                <a href="mailto:john.smith@acmecorp.com">john.smith@acmecorp.com</a>
                              </p>
                            </Col>
                            <Col md={6}>
                              <small className="text-subtle">Mobile Number</small>
                              <p className="digit_txt">(555) 987-6543</p>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <ContactInformationViewPage />
                </div>
                <div id="PolicyTerm" className="scrollTo" ref={refs.PolicyTerm}></div>
                <div className="col-12 mb-3">
                  <Accordion
                    activeKey={businessActiveKey}
                    onSelect={(k) => setBusinessActiveKey(k)}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-building h-3.5 w-3.5 mr-1.5"
                          >
                            <rect width="16" height="20" x="4" y="2" rx="2" ry="2"></rect>
                            <path d="M9 22v-4h6v4"></path>
                            <path d="M8 6h.01"></path>
                            <path d="M16 6h.01"></path>
                            <path d="M12 6h.01"></path>
                            <path d="M12 10h.01"></path>
                            <path d="M12 14h.01"></path>
                            <path d="M16 10h.01"></path>
                            <path d="M16 14h.01"></path>
                            <path d="M8 10h.01"></path>
                            <path d="M8 14h.01"></path>
                          </svg>

                          <span> Business & Legal Structure</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <Row className="mb-3">
                            <Col md={4}>
                              <small className="text-subtle">DBA (Doing Business As)</small>
                              <p className="digit_txt">Acme Corp</p>
                            </Col>
                            <Col md={4}>
                              <small className="text-subtle">Legal Structure</small>
                              <p className="digit_txt">Corporation</p>
                            </Col>
                            <Col md={4}>
                              <small className="text-subtle">NAICS</small>
                              <p className="digit_txt">541511 - Custom Computer Programming</p>
                            </Col>
                          </Row>

                          <Row className="mb-3">
                            <Col md={4}>
                              <small className="text-subtle">SIC</small>
                              <p className="digit_txt">7371 - Computer Programming Services</p>
                            </Col>
                            <Col md={8}>
                              <small className="text-subtle">Description</small>
                              <p className="digit_txt">
                                Acme Corporation develops custom software solutions for enterprise
                                clients, specializing in cloud-based applications and data analytics
                                platforms.
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div id="Locations" className="scrollTo" ref={refs.Locations}></div>
                <div className="col-12 mb-3">
                  <Accordion activeKey={addressActiveKey} onSelect={(k) => setaddressActiveKey(k)}>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 2C8.686 2 6 4.686 6 8C6 12.418 12 21 12 21C12 21 18 12.418 18 8C18 4.686 15.314 2 12 2Z"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <circle
                              cx="12"
                              cy="8"
                              r="2"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>

                          <span>Address and Location Information</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <Row className="mb-4">
                            {/* Primary Address */}
                            <Col md={6}>
                              <Card
                                className="p-3 shadow-sm mb-0 border"
                                style={{ height: '298px', overflowY: 'auto' }}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <h5 className="block-header">Primary Address</h5>
                                  <Badge className="light-green-bg">Primary</Badge>
                                </div>
                                <Row className="mt-3">
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">ZIP</small>
                                    <p className="digit_txt">94105</p>
                                  </Col>
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">State</small>
                                    <p className="digit_txt">California</p>
                                  </Col>
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">County</small>
                                    <p className="digit_txt">San Francisco</p>
                                  </Col>
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">City</small>
                                    <p className="digit_txt">San Francisco</p>
                                  </Col>

                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">Latitude</small>
                                    <p className="digit_txt">37.7749</p>
                                  </Col>
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">Longitude</small>
                                    <p className="digit_txt">-122.4194</p>
                                  </Col>
                                  <Col md={12} className="mb-3">
                                    <small className="text-subtle">Street Address</small>
                                    <p className="digit_txt">123 Market St</p>
                                  </Col>
                                </Row>
                              </Card>
                            </Col>

                            {/* Mailing Address */}
                            <Col md={6} className="mb-3">
                              <Card
                                className="p-3 shadow-sm border mb-0"
                                style={{ height: '298px', overflowY: 'auto' }}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <h5 className="block-header">Mailing Address</h5>
                                  <Badge className="ice-blue" text="dark">
                                    Same as Primary
                                  </Badge>
                                </div>
                                <Row className="mt-3">
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">ZIP</small>
                                    <p className="digit_txt">94105</p>
                                  </Col>
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">State</small>
                                    <p className="digit_txt">California</p>
                                  </Col>
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">County</small>
                                    <p className="digit_txt">San Francisco</p>
                                  </Col>
                                  <Col md={6} className="mb-3">
                                    <small className="text-subtle">City</small>
                                    <p className="digit_txt">San Francisco</p>
                                  </Col>
                                  <Col md={12} className="mb-3">
                                    <small className="text-subtle">Street Address</small>
                                    <p className="digit_txt">123 Market St</p>
                                  </Col>
                                </Row>
                              </Card>
                            </Col>
                          </Row>

                          {/* Locations Table */}
                          <h4 className="block-header">Locations</h4>

                          <Table bordered hover className="custom-table shadow-sm p-3 mt-2 mb-4">
                            <thead>
                              <tr>
                                <th className="table-header">Location #</th>
                                <th className="table-header">ZIP</th>
                                <th className="table-header">State</th>
                                <th className="table-header">City</th>
                                <th className="table-header">Address</th>
                                <th className="table-header">SIC</th>
                                <th className="table-header">NAICS</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="table-data">1</td>
                                <td className="table-data">94105</td>
                                <td className="table-data">CA</td>
                                <td className="table-data">San Francisco</td>
                                <td className="table-data">123 Market St</td>
                                <td className="table-data">7371</td>
                                <td className="table-data">541511</td>
                              </tr>
                              <tr>
                                <td className="table-data">2</td>
                                <td className="table-data">10001</td>
                                <td className="table-data">NY</td>
                                <td className="table-data">New York</td>
                                <td className="table-data">456 Broadway</td>
                                <td className="table-data">7371</td>
                                <td className="table-data">541511</td>
                              </tr>
                            </tbody>
                          </Table>

                          <h4 className="block-header">Location Class Codes</h4>

                          <Table bordered hover className="custom-table shadow-sm p-3 mt-2">
                            <thead className="bg-light">
                              <tr>
                                <th className="table-header">Location</th>
                                <th className="table-header">Class Code</th>
                                <th className="table-header">Full Time</th>
                                <th className="table-header">Part Time</th>
                                <th className="table-header">Payroll</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="table-data">San Francisco</td>
                                <td className="table-data">1234</td>
                                <td className="table-data">10</td>
                                <td className="table-data">2</td>
                                <td className="table-data">$250,000</td>
                              </tr>
                              <tr>
                                <td className="table-data">New York</td>
                                <td className="table-data">5678</td>
                                <td className="table-data">8</td>
                                <td className="table-data">3</td>
                                <td className="table-data">$180,000</td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div
                  id="LocationClassCodes"
                  className="scrollTo"
                  ref={refs.LocationClassCodes}
                ></div>
                <div className="col-12 mb-3">
                  <Accordion
                    activeKey={employmentActiveKey}
                    onSelect={(k) => setemploymentActiveKey(k)}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-dollar-sign h-3.5 w-3.5 mr-1.5"
                          >
                            <line x1="12" x2="12" y1="2" y2="22"></line>
                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                          </svg>

                          <span>Employment & Payroll Details</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <Row className="gy-3">
                            {/* First Row */}
                            <Col md={6}>
                              <p className="text-subtle">Annual Payroll</p>
                              <p className="digit_txt fw-medium">$5,500,000</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Governing Class Code</p>
                              <p className="digit_txt">8810 - Clerical Office Employees</p>
                            </Col>

                            {/* Second Row */}
                            <Col md={6}>
                              <p className="text-subtle">Full Time Employees</p>
                              <p className="digit_txt">40</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Part Time Employees</p>
                              <p className="digit_txt">10</p>
                            </Col>

                            {/* Third Row */}
                            <Col md={6}>
                              <p className="text-subtle">Years in Business</p>
                              <p className="digit_txt">12</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Years as Owner</p>
                              <p className="digit_txt">8</p>
                            </Col>

                            {/* Fourth Row */}
                            <Col md={6}>
                              <p className="text-subtle">NCCI/Rating Bureau ID</p>
                              <p className="digit_txt">RB-12345678</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Prior Insurance</p>
                              <p className="digit_txt">Yes</p>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div id="RatingInformation" className="scrollTo" ref={refs.RatingInformation}></div>
                <div className="col-12 mb-3">
                  <Accordion activeKey={ratingActiveKey} onSelect={(k) => setratingActiveKey(k)}>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-shield h-3.5 w-3.5 mr-1.5"
                          >
                            <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                          </svg>

                          <span>Rating & Policy Limits</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <Row className="gy-3">
                            <Col md={6}>
                              <p className="text-subtle">Policy Limit – Each Accident</p>
                              <p className="digit_txt">$1,000,000</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Other Coverage</p>
                              <p className="digit_txt">None</p>
                            </Col>

                            <Col md={6}>
                              <p className="text-subtle">Policy Limit – Disease</p>
                              <p className="digit_txt">$1,000,000</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Exp. Mod Factor</p>
                              <p className="digit_txt">0.95</p>
                            </Col>

                            <Col md={6}>
                              <p className="text-subtle">Limit – Disease (Each Employee)</p>
                              <p className="digit_txt">$1,000,000</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Exp. Mod Date</p>
                              <p className="digit_txt">January 15, 2023</p>
                            </Col>

                            <Col md={6}>
                              <p className="text-subtle">U.S.L&H</p>
                              <p className="digit_txt">No</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Risk ID</p>
                              <p className="digit_txt">RISK-98765</p>
                            </Col>

                            <Col md={6}>
                              <p className="text-subtle">Foreign Coverage</p>
                              <p className="digit_txt">No</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">FELA</p>
                              <p className="digit_txt">$500,000</p>
                            </Col>

                            <Col md={6}>
                              <p className="text-subtle">Managed Care</p>
                              <p className="digit_txt">No</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Waiver of Subrogation</p>
                              <p className="digit_txt">Yes</p>
                            </Col>

                            <Col md={6}>
                              <p className="text-subtle">Voluntary Comp</p>
                              <p className="digit_txt">No</p>
                            </Col>
                            <Col md={6}>
                              <p className="text-subtle">Waiver Amount</p>
                              <p className="digit_txt">$2,500</p>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div id="Deductibles" className="scrollTo" ref={refs.Deductibles}></div>
                <div className="col-12 mb-3">
                  <Accordion
                    activeKey={deductibleActiveKey}
                    onSelect={(k) => setdeductibleActiveKey(k)}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-wallet h-3.5 w-3.5 mr-1.5"
                          >
                            <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
                            <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                          </svg>

                          <span>Deductibles</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          {/* Deductibles Info */}
                          <Row className="mb-4">
                            {/* Medical */}
                            <Col md={4}>
                              <h6 className="fw-medium mb-3">Medical</h6>
                              <p className="text-subtle mb-2">Status</p>

                              <Badge className="applied mb-3" text="light">
                                Applied
                              </Badge>
                              <p className="text-subtle mb-1">Amount</p>
                              <p className="digit_txt mb-3">$5,000</p>
                              <p className="text-subtle mb-1">Percentage</p>
                              <p className="digit_txt">0%</p>
                            </Col>

                            {/* Indemnity */}
                            <Col md={4}>
                              <h6 className="fw-medium mb-3">Indemnity</h6>
                              <p className="text-subtle mb-2">Status</p>
                              <Badge className="rounded-pill applied mb-3">Applied</Badge>
                              <p className="text-subtle mb-1">Amount</p>
                              <p className="digit_txt mb-3">$2,500</p>
                              <p className="text-subtle mb-1">Percentage</p>
                              <p className="digit_txt">0%</p>
                            </Col>

                            {/* Other */}
                            <Col md={4}>
                              <h6 className="fw-medium mb-3">Other</h6>
                              <p className="text-subtle mb-2">Status</p>
                              {/* <Badge bg="light" text="dark" className="border mb-3">Not Applied</Badge> */}
                              <Badge bg="light" text="dark" className="border mb-3">
                                Not Applied
                              </Badge>
                              <p className="text-subtle mb-1">Amount</p>
                              <p className="digit_txt mb-3">-</p>
                              <p className="text-subtle mb-1">Percentage</p>
                              <p className="digit_txt">-</p>
                            </Col>
                          </Row>

                          {/* State Deductibles Table */}
                          <h4 className="block-header">State Deductibles</h4>
                          <Table bordered hover className="custom-table shadow-sm p-3 mt-2 mb-4">
                            <thead>
                              <tr>
                                <th className="table-header">State</th>
                                <th className="table-header">Deductible Type</th>
                                <th className="table-header">Deductible Amount</th>
                                <th className="table-header">Deductible %</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="table-data">CA</td>
                                <td className="table-data">Medical</td>
                                <td className="table-data">$5,000</td>
                                <td className="table-data">0%</td>
                              </tr>
                              <tr>
                                <td className="table-data">NY</td>
                                <td className="table-data">Indemnity</td>
                                <td className="table-data">$2,500</td>
                                <td className="table-data">0%</td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div
                  id="IncludedExcludedOfficers"
                  className="scrollTo"
                  ref={refs.IncludedExcludedOfficers}
                ></div>
                <div className="col-12 mb-3">
                  <Accordion activeKey={includeActiveKey} onSelect={(k) => setincludeActiveKey(k)}>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-user-cog h-3.5 w-3.5 mr-1.5"
                          >
                            <circle cx="18" cy="15" r="3"></circle>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M10 15H6a4 4 0 0 0-4 4v2"></path>
                            <path d="m21.7 16.4-.9-.3"></path>
                            <path d="m15.2 13.9-.9-.3"></path>
                            <path d="m16.6 18.7.3-.9"></path>
                            <path d="m19.1 12.2.3-.9"></path>
                            <path d="m19.6 18.7-.4-1"></path>
                            <path d="m16.8 12.3-.4-1"></path>
                            <path d="m14.3 16.6 1-.4"></path>
                            <path d="m20.7 13.8 1-.4"></path>
                          </svg>

                          <span>Included/Excluded Officers</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <h4 className="block-header">Officers</h4>

                          <Table bordered hover className="custom-table shadow-sm p-3 mt-2 ">
                            <thead>
                              <tr>
                                <th className="table-header">State</th>
                                <th className="table-header">Name</th>
                                <th className="table-header">Annual Pay</th>
                                <th className="table-header">Ownership</th>
                                <th className="table-header">Include/Exclude</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="table-data">CA</td>
                                <td className="table-data">John Smith</td>
                                <td className="table-data">$250,000</td>
                                <td className="table-data">45%</td>
                                <td>
                                  <Badge className="Include">Include</Badge>
                                </td>
                              </tr>
                              <tr>
                                <td className="table-data">CA</td>
                                <td className="table-data">Jane Doe</td>
                                <td className="table-data">$225,000</td>
                                <td className="table-data">35%</td>
                                <td>
                                  <Badge className="Include">Include</Badge>
                                </td>
                              </tr>
                              <tr>
                                <td className="table-data">NY</td>
                                <td className="table-data">Robert Johnson</td>
                                <td className="table-data">$200,000</td>
                                <td className="table-data">20%</td>
                                <td>
                                  <Badge bg="light" text="dark" className="border">
                                    Exclude
                                  </Badge>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>

                <div
                  id="PreQualifierQuestions"
                  className="scrollTo"
                  ref={refs.PreQualifierQuestions}
                ></div>
                <div
                  id="UnderwritingInformation"
                  className="scrollTo"
                  ref={refs.UnderwritingInformation}
                ></div>
                <div className="col-12 mb-3">
                  <Accordion
                    activeKey={questionActiveKey}
                    onSelect={(k) => setquestionActiveKey(k)}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm1 15h-2v-2h2zm0-4h-2V7h2z" />
                          </svg>

                          <span>Pre-Qualifier + Underwriting Questions</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <Row className="g-4">
                            {/* Left Column */}

                            <Col md={12} lg={6}>
                              <Row className="align-items-center mb-3 pb-2">
                                <Col className="text-subtle">
                                  Sub-contractors / Independent Contractors
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content=" Sub-contractors / Independent Contractors"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge bg="light" text="dark" className="border rounded-pill">
                                    No
                                  </Badge>
                                </Col>
                              </Row>

                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  Group transportation
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content=" Group transportation"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge bg="light" text="dark" className="border rounded-pill">
                                    No
                                  </Badge>
                                </Col>
                              </Row>

                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  Employee health plans
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content="Employee health plans"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge className="rounded-pill yes">Yes</Badge>
                                </Col>
                              </Row>

                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  Aircraft/Watercraft usage
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content=" Aircraft/Watercraft usage"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge bg="light" text="dark" className="border rounded-pill">
                                    No
                                  </Badge>
                                </Col>
                              </Row>

                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  Convicted of fraud/bribery/arson
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content="  Convicted of fraud/bribery/arson"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge bg="light" text="dark" className="border rounded-pill">
                                    No
                                  </Badge>
                                </Col>
                              </Row>
                            </Col>

                            {/* Right Column */}
                            <Col md={12} lg={6}>
                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  Motor vehicles for business
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content="Motor vehicles for business"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge className="rounded-pill yes">Yes</Badge>
                                </Col>
                              </Row>

                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  Prior coverage declined/cancelled
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content=" Prior coverage declined/cancelled"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge bg="light" text="dark" className="border rounded-pill">
                                    No
                                  </Badge>
                                </Col>
                              </Row>

                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  Leasing employees
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content="  Leasing employees"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge bg="light" text="dark" className="border rounded-pill">
                                    No
                                  </Badge>
                                </Col>
                              </Row>

                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  24-hour operation
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content=" 24-hour operation"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge bg="light" text="dark" className="border rounded-pill">
                                    No
                                  </Badge>
                                </Col>
                              </Row>

                              <Row className="align-items-center mb-3  pb-2">
                                <Col className="text-subtle">
                                  Bankruptcy / tax lien / foreclosure
                                  <i
                                    className="info-icon"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content=" Bankruptcy / tax lien / foreclosure"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 13 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                        fill="#76D1B9"
                                      />
                                      <path
                                        d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                        fill="none"
                                        stroke="#76D1B9"
                                      />
                                    </svg>
                                  </i>
                                  <ReactTooltip
                                    id="my-tooltip"
                                    style={{ backgroundColor: '#2563eb' }}
                                  ></ReactTooltip>
                                </Col>
                                <Col xs="auto">
                                  <Badge bg="light" text="dark" className="border rounded-pill">
                                    No
                                  </Badge>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div id="LossDetails" className="scrollTo" ref={refs.LossDetails}></div>
                <div className="col-12 mb-3">
                  <Accordion
                    activeKey={lossdetailActiveKey}
                    onSelect={(k) => setlossdetailActiveKey(k)}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-file-chart-column-increasing h-3.5 w-3.5 mr-1.5"
                          >
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                            <path d="M8 18v-2"></path>
                            <path d="M12 18v-4"></path>
                            <path d="M16 18v-6"></path>
                          </svg>

                          <span>Loss Details</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <h4 className="block-header">Loss History</h4>

                          <Table bordered hover className="custom-table shadow-sm p-3 mt-2 ">
                            <thead>
                              <tr>
                                <th className="table-header">Carrier</th>
                                <th className="table-header">Loss Date</th>
                                <th className="table-header">Loss Amount</th>
                                <th className="table-header">Paid/Denied</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="table-data">ABC Insurance</td>
                                <td className="table-data">01/15/2022</td>
                                <td className="table-data">$12,500</td>
                                <td className="table-data">
                                  <Badge className="rounded-pill paid">paid</Badge>
                                </td>
                              </tr>
                              <tr>
                                <td className="table-data">XYZ Insurance</td>
                                <td className="table-data">05/22/2021</td>
                                <td className="table-data">$8,750</td>
                                <td className="table-data">
                                  <Badge className="rounded-pill paid">paid</Badge>
                                </td>
                              </tr>
                              <tr>
                                <td className="table-data">DEF Insurance</td>
                                <td className="table-data">11/10/2020</td>
                                <td className="table-data">$5,000</td>
                                <td className="table-data">
                                  <Badge className="rounded-pill denied">Denied</Badge>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div
                  id="AdditionalInformationForms"
                  className="scrollTo"
                  ref={refs.AdditionalInformationForms}
                ></div>
                <div className="col-12 mb-3">
                  <Accordion
                    activeKey={additionformActiveKey}
                    onSelect={(k) => setadditionformActiveKey(k)}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-file-spreadsheet h-3.5 w-3.5 mr-1.5"
                          >
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                            <path d="M8 13h2"></path>
                            <path d="M14 13h2"></path>
                            <path d="M8 17h2"></path>
                            <path d="M14 17h2"></path>
                          </svg>

                          <span>Additional Forms</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <h4 className="block-header">Forms</h4>

                          <Table bordered hover className="custom-table shadow-sm p-3 mt-2 ">
                            <thead>
                              <tr>
                                <th className="table-header">Form Name</th>
                                <th className="table-header">Related State</th>
                                <th className="table-header">SIC</th>
                                <th className="table-header">NAICS</th>
                                <th className="table-header">Class Code</th>
                                <th className="table-header">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="table-data">WC-CA-01</td>
                                <td className="table-data">CA</td>
                                <td className="table-data">7371</td>
                                <td className="table-data">541511</td>
                                <td className="table-data">8810</td>
                                <td className="table-data">
                                  <svg
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M.5 9.9V14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9a.5.5 0 0 0-1 0V14H1.5V9.9a.5.5 0 0 0-1 0z" />
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 1 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                  </svg>
                                </td>
                              </tr>
                              <tr>
                                <td className="table-data">WC-NY-02</td>
                                <td className="table-data">NY</td>
                                <td className="table-data">7371</td>
                                <td className="table-data">541511</td>
                                <td className="table-data">8810</td>
                                <td className="table-data">
                                  <svg
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M.5 9.9V14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9a.5.5 0 0 0-1 0V14H1.5V9.9a.5.5 0 0 0-1 0z" />
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 1 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                  </svg>
                                </td>
                              </tr>
                              <tr>
                                <td className="table-data">WC-ALL-03</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">
                                  <svg
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M.5 9.9V14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9a.5.5 0 0 0-1 0V14H1.5V9.9a.5.5 0 0 0-1 0z" />
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 1 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                  </svg>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div id="QuotedPremium" className="scrollTo" ref={refs.QuotedPremium}></div>
                <div className="col-12 mb-3">
                  <Accordion
                    activeKey={quotedpremiumActiveKey}
                    onSelect={(k) => setquotedpremiumActiveKey(k)}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="panelHeaderTitle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-receipt h-3.5 w-3.5 mr-1.5"
                          >
                            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"></path>
                            <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path>
                            <path d="M12 17.5v-11"></path>
                          </svg>

                          <span>Quoted Premium</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="summary_details-container ">
                          <Row className="quote-row">
                            <Col md={8} className="quote-message-col">
                              <div className="section-label">Quote Message</div>
                              <div className="quote-message-box">
                                <p>
                                  This quote is based on the information provided and is subject to
                                  underwriting review. Premium may change based on final
                                  underwriting.
                                </p>
                              </div>
                            </Col>

                            <Col md={4} className="quote-amount-col">
                              <div className="section-label">Quoted Amount</div>
                              <div className="amount-value">$12,450.00</div>
                            </Col>
                          </Row>

                          <h4 className="block-header">Quote Documents</h4>

                          <Table bordered hover className="custom-table shadow-sm p-3 mt-2 ">
                            <thead>
                              <tr>
                                <th className="table-header">Document Name</th>
                                <th className="table-header">Related State</th>
                                <th className="table-header">SIC</th>
                                <th className="table-header">NAICS</th>
                                <th className="table-header">Class Code</th>
                                <th className="table-header">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="table-data">Quote Summary</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">
                                  <svg
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M.5 9.9V14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9a.5.5 0 0 0-1 0V14H1.5V9.9a.5.5 0 0 0-1 0z" />
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 1 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                  </svg>
                                </td>
                              </tr>
                              <tr>
                                <td className="table-data">Policy Declaration</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">All</td>
                                <td className="table-data">
                                  <svg
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M.5 9.9V14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9a.5.5 0 0 0-1 0V14H1.5V9.9a.5.5 0 0 0-1 0z" />
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 1 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                  </svg>
                                </td>
                              </tr>
                              <tr>
                                <td className="table-data">State Endorsement</td>
                                <td className="table-data">CA</td>
                                <td className="table-data">7371</td>
                                <td className="table-data">541511</td>
                                <td className="table-data">8810</td>
                                <td className="table-data">
                                  <svg
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M.5 9.9V14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9a.5.5 0 0 0-1 0V14H1.5V9.9a.5.5 0 0 0-1 0z" />
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 1 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                  </svg>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>

              <div className="col-12 col-md-12 col-lg-3">
                <div className="sticky-top right-bg">
                  <Card
                    className="p-3 shadow-sm"
                    style={{
                      borderRadius: '10px',
                      marginBottom: '1rem',
                      height: 'calc(100vh - 134px)',
                    }}
                  >
                    {/* Company Name */}
                    <div className="text-center text-md-start mb-2">
                      <h5 className="fw-medium mb-1">Acme Corporation</h5>

                      <small className="subtitle_hd">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 17 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.75911 18H13.8614C15.8305 18 16.8102 17.1184 16.8102 15.3722V7.74906C16.8102 6.66605 16.6771 6.19587 15.9161 5.50746L10.6652 0.797552C9.94225 0.14271 9.35244 0 8.27754 0H3.75911C1.79954 0 0.810242 0.889934 0.810242 2.6362V15.3722C0.810242 17.1269 1.79954 18 3.75911 18ZM3.83521 16.6483C2.8554 16.6483 2.34174 16.1866 2.34174 15.347V2.66139C2.34174 1.83023 2.8554 1.35167 3.84471 1.35167H8.06824V6.22947C8.06824 7.2873 8.67704 7.80781 9.85661 7.80781H15.2787V15.347C15.2787 16.1866 14.7746 16.6483 13.7853 16.6483H3.83521ZM10.0278 6.54011C9.65684 6.54011 9.50464 6.40578 9.50464 6.06996V1.61194L14.9838 6.54011H10.0278Z"
                            fill="#333"
                          />
                        </svg>
                        Policy #: <strong>WC-2023-0042</strong>
                      </small>
                    </div>

                    {/* Status Badges */}
                    <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-2 mb-3">
                      <span className="badge bg-quote">Quote</span>
                      <span className="badge light-orange-bg text-dark">Expires in 45 days</span>
                    </div>

                    <hr className="my-3" />

                    <Row className="text-start">
                      {/* Policy Details With Icons */}
                      <Col xs={12} sm={12} md={6}>
                        <div className="mb-3 h-100">
                          <div className="details-block ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#333"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-building h-4 w-4 text-muted-foreground"
                            >
                              <rect width="16" height="20" x="4" y="2" rx="2" ry="2"></rect>
                              <path d="M9 22v-4h6v4"></path>
                              <path d="M8 6h.01"></path>
                              <path d="M16 6h.01"></path>
                              <path d="M12 6h.01"></path>
                              <path d="M12 10h.01"></path>
                              <path d="M12 14h.01"></path>
                              <path d="M16 10h.01"></path>
                              <path d="M16 14h.01"></path>
                              <path d="M8 10h.01"></path>
                              <path d="M8 14h.01"></path>
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle">Business Type</small>
                              <div className="digit_txt">Corporation</div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6}>
                        <div className=" h-100 mb-3">
                          <div className="details-block ">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.8 16H15.2C15.4122 16 15.6157 15.9157 15.7657 15.7657C15.9157 15.6157 16 15.4122 16 15.2V3.2C16 2.98783 15.9157 2.78434 15.7657 2.63431C15.6157 2.48429 15.4122 2.4 15.2 2.4H12V0.8C12 0.587827 11.9157 0.384344 11.7657 0.234315C11.6157 0.0842854 11.4122 0 11.2 0C10.9878 0 10.7843 0.0842854 10.6343 0.234315C10.4843 0.384344 10.4 0.587827 10.4 0.8V2.4H5.6V0.8C5.6 0.587827 5.51571 0.384344 5.36569 0.234315C5.21566 0.0842854 5.01217 0 4.8 0C4.58783 0 4.38434 0.0842854 4.23431 0.234315C4.08429 0.384344 4 0.587827 4 0.8V2.4H0.8C0.587827 2.4 0.384344 2.48429 0.234315 2.63431C0.0842854 2.78434 0 2.98783 0 3.2V15.2C0 15.4122 0.0842854 15.6157 0.234315 15.7657C0.384344 15.9157 0.587827 16 0.8 16ZM1.6 4H14.4V6.4H1.6V4ZM1.6 8H14.4V14.4H1.6V8Z"
                                fill="#333"
                              />
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle">Effective Date</small>
                              <div className="digit_txt">03/31/2024</div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6}>
                        <div className="mb-3 h-100">
                          <div className="details-block ">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.8 16H15.2C15.4122 16 15.6157 15.9157 15.7657 15.7657C15.9157 15.6157 16 15.4122 16 15.2V3.2C16 2.98783 15.9157 2.78434 15.7657 2.63431C15.6157 2.48429 15.4122 2.4 15.2 2.4H12V0.8C12 0.587827 11.9157 0.384344 11.7657 0.234315C11.6157 0.0842854 11.4122 0 11.2 0C10.9878 0 10.7843 0.0842854 10.6343 0.234315C10.4843 0.384344 10.4 0.587827 10.4 0.8V2.4H5.6V0.8C5.6 0.587827 5.51571 0.384344 5.36569 0.234315C5.21566 0.0842854 5.01217 0 4.8 0C4.58783 0 4.38434 0.0842854 4.23431 0.234315C4.08429 0.384344 4 0.587827 4 0.8V2.4H0.8C0.587827 2.4 0.384344 2.48429 0.234315 2.63431C0.0842854 2.78434 0 2.98783 0 3.2V15.2C0 15.4122 0.0842854 15.6157 0.234315 15.7657C0.384344 15.9157 0.587827 16 0.8 16ZM1.6 4H14.4V6.4H1.6V4ZM1.6 8H14.4V14.4H1.6V8Z"
                                fill="#333"
                              />
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle"> Expiration Date</small>
                              <div className="digit_txt">03/31/2025</div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6}>
                        <div className=" h-100 mb-3">
                          <div className="details-block ">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.8 16H15.2C15.4122 16 15.6157 15.9157 15.7657 15.7657C15.9157 15.6157 16 15.4122 16 15.2V3.2C16 2.98783 15.9157 2.78434 15.7657 2.63431C15.6157 2.48429 15.4122 2.4 15.2 2.4H12V0.8C12 0.587827 11.9157 0.384344 11.7657 0.234315C11.6157 0.0842854 11.4122 0 11.2 0C10.9878 0 10.7843 0.0842854 10.6343 0.234315C10.4843 0.384344 10.4 0.587827 10.4 0.8V2.4H5.6V0.8C5.6 0.587827 5.51571 0.384344 5.36569 0.234315C5.21566 0.0842854 5.01217 0 4.8 0C4.58783 0 4.38434 0.0842854 4.23431 0.234315C4.08429 0.384344 4 0.587827 4 0.8V2.4H0.8C0.587827 2.4 0.384344 2.48429 0.234315 2.63431C0.0842854 2.78434 0 2.98783 0 3.2V15.2C0 15.4122 0.0842854 15.6157 0.234315 15.7657C0.384344 15.9157 0.587827 16 0.8 16ZM1.6 4H14.4V6.4H1.6V4ZM1.6 8H14.4V14.4H1.6V8Z"
                                fill="#333"
                              />
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle"> Current Date</small>
                              <div className="digit_txt">11/22/2024</div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6}>
                        <div className="mb-3 h-100">
                          <div className="details-block ">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L14.5858 2.58579C14.2107 2.21071 13.702 2 13.1716 2H6Z"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M14 2V8H20"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8 12H16"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8 16H14"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle">IMS Control Number</small>
                              <div className="digit_txt">IMS-2024-001</div>
                            </div>
                          </div>
                        </div>
                      </Col>

                      <Col xs={12} sm={12} md={6}>
                        <div className="mb-3 h-100">
                          <div className="details-block ">
                            <svg
                              width="16"
                              height="14"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 10C1 11.1819 1.23279 12.3522 1.68508 13.4442C2.13738 14.5361 2.80031 15.5282 3.63604 16.364C4.47177 17.1997 5.46392 17.8626 6.55585 18.3149C7.64778 18.7672 8.8181 19 10 19C11.1819 19 12.3522 18.7672 13.4442 18.3149C14.5361 17.8626 15.5282 17.1997 16.364 16.364C17.1997 15.5282 17.8626 14.5361 18.3149 13.4442C18.7672 12.3522 19 11.1819 19 10C19 8.8181 18.7672 7.64778 18.3149 6.55585C17.8626 5.46392 17.1997 4.47177 16.364 3.63604C15.5282 2.80031 14.5361 2.13738 13.4442 1.68508C12.3522 1.23279 11.1819 1 10 1C8.8181 1 7.64778 1.23279 6.55585 1.68508C5.46392 2.13738 4.47177 2.80031 3.63604 3.63604C2.80031 4.47177 2.13738 5.46392 1.68508 6.55585C1.23279 7.64778 1 8.8181 1 10Z"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M11.867 7.75C11.621 7.27 11.159 6.981 10.667 7H9.333C8.597 7 8 7.67 8 8.5C8 9.327 8.597 9.999 9.333 9.999H10.667C11.403 9.999 12 10.67 12 11.499C12 12.327 11.403 12.998 10.667 12.998H9.333C8.841 13.017 8.379 12.728 8.133 12.248M10 5V7M10 13V15"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle">Premium</small>
                              <div className="digit_txt light-green-bg rounded px-2">
                                $12,450.00
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6}>
                        <div className="mb-3 h-100">
                          <div className="details-block ">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <circle cx="12" cy="12" r="10" stroke="#333" strokeWidth="2" />
                              <path
                                d="M12 8V12L14.5 14"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle">Risk Level</small>
                              <div className="digit_txt rounded bg-light-danger px-2">Medium</div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6}>
                        <div className=" h-100 mb-3">
                          <div className="details-block ">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M22 16.92V19A2 2 0 0 1 20 21C10.61 21 3 13.39 3 4A2 2 0 0 1 5 2H7.08A1 1 0 0 1 8.07 2.92L9 6A1 1 0 0 1 8.47 7L6.6 8.87A16 16 0 0 0 15.13 17.4L17 15.53A1 1 0 0 1 18 15L21.08 15.93A1 1 0 0 1 22 16.92Z"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle">Phone</small>
                              <div className="digit_txt">(555) 123-4567</div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={12}>
                        <div className="mb-3 h-100">
                          <div className="details-block ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#333"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-calendar-clock h-3.5 w-3.5 text-muted-foreground"
                            >
                              <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"></path>
                              <path d="M16 2v4"></path>
                              <path d="M8 2v4"></path>
                              <path d="M3 10h5"></path>
                              <path d="M17.5 17.5 16 16.3V14"></path>
                              <circle cx="16" cy="16" r="6"></circle>
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle">Policy Term</small>
                              <div className="digit_txt">01/01/2023 - 01/01/2024</div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={12}>
                        <div className="mb-3 h-100">
                          <div className="details-block ">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4Z"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M22 6L12 13L2 6"
                                stroke="#333"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <div className="details-text">
                              <small className="text-subtle">Contact Email</small>
                              <div className="digit_txt">
                                <Link href="">linda@fromcreative.com</Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* Progress Bar */}
                    <div className="mt-4">
                      <ProgressBar now={65} variant="success" className="mt-1" />
                      <small className="proress_txt">Application completion: 85%</small>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="quote_buttongroup">
          <div className="form-footer-actions">
            {/* Cancel Button */}
            <Button variant="outline-cancel" size="sm" className="button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5864A1"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-x h-3 w-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
              Cancel
            </Button>

            <Button variant="primary-save" size="sm" className="button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-save h-3 w-3 mr-2"
              >
                <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"></path>
                <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"></path>
                <path d="M7 3v4a1 1 0 0 0 1 1h7"></path>
              </svg>
              Save
            </Button>

            <Button variant="primary-save" size="sm" className="button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-file-text h-3 w-3 mr-2"
              >
                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                <path d="M10 9H8"></path>
                <path d="M16 13H8"></path>
                <path d="M16 17H8"></path>
              </svg>
              Generate Quote
            </Button>

            <Button variant="primary-save" size="sm" className="button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-right h-3 w-3 mr-2"
              >
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
              Proceed to Bind
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InsuredInformationViewPage;
